import { render, staticRenderFns } from "./BtnGradient.vue?vue&type=template&id=36bb8dbb&scoped=true&"
import script from "./BtnGradient.vue?vue&type=script&lang=js&"
export * from "./BtnGradient.vue?vue&type=script&lang=js&"
import style0 from "./BtnGradient.vue?vue&type=style&index=0&id=36bb8dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb8dbb",
  null
  
)

export default component.exports